var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._b({attrs:{"items":_vm.items,"label":_vm.$t('country'),"item-text":"name","item-value":"code"},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}},'v-select',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }